import { createAction, props } from '@ngrx/store';
import { ZoneSubscription } from '../../../zones/models/zone-subscription';
import { ChangeStateModel } from '../../../zones/models/change-state-model';
import { ZoneUnitsSubscription } from '../../../zones/models/zone-units-subscription';

export const getZonesSubscriptions = createAction(
  '[ZonesSubscriptions] Get Zones Subscriptions'
);
export const createZoneSubscription = createAction(
  '[ZonesSubscriptions] Create Zone Subscription',
  props<{data: ZoneSubscription}>()
);
export const editZoneSubscription = createAction(
  '[ZonesSubscriptions] Edit Zone Subscription',
  props<{data: ZoneSubscription}>()
);

export const editUnitsZoneSubscription = createAction(
    '[ZonesSubscriptions] Edit Units Zone Subscription',
    props<{data: ZoneUnitsSubscription}>()
    );

export const deleteZoneSubscription = createAction(
  '[ZonesSubscriptions] Delete Zone Subscription',
  props<{zoneId: number}>()
);
export const changeState = createAction(
  '[ZonesSubscriptions] Change State',
  props<{data: ChangeStateModel}>()
);

export type ZonesSubscriptionsActionsUnion = ReturnType<
  typeof getZonesSubscriptions |
  typeof createZoneSubscription |
  typeof editZoneSubscription |
  typeof editUnitsZoneSubscription |
  typeof deleteZoneSubscription |
  typeof changeState
  >;
